import { isObject } from './general.guard';
import { ArtifactMarkdownV3, ArtifactCodeV3 } from '../api';

export const isArtifactMarkdown = (
  data: unknown,
): data is ArtifactMarkdownV3 => {
  const artifactMarkdown = data as ArtifactMarkdownV3;

  if (!artifactMarkdown || !isObject(artifactMarkdown)) {
    return false;
  }

  if ('fullMarkdown' in artifactMarkdown) {
    return true;
  }

  return false;
};

export const isArtifactCode = (data: unknown): data is ArtifactCodeV3 => {
  const artifactCode = data as ArtifactCodeV3;

  if (!artifactCode || !isObject(artifactCode)) {
    return false;
  }

  if ('code' in artifactCode) {
    return true;
  }

  return false;
};
